<script lang="ts">
  import { Button, buttonVariants } from "$lib/components/ui/button";
  import * as Dialog from "$lib/components/ui/dialog/index.js";
  import { Input } from "$lib/components/ui/input";
  import { Label } from "$lib/components/ui/label";
  import { projectDraft } from "$src/application/projects/stores/projectStore";
  import { type PaymentSchedule } from "$src/domain/projects/details/PaymentSchedule";
  import { formatCurrency } from "$src/presentation/core/currencyUtils";
  import { CornerLeftUp } from "lucide-svelte";
  import { createEventDispatcher } from "svelte";
  import { t } from "svelte-i18n";

  export let title: string = "";
  export let amount: number;
  export let payment: PaymentSchedule;

  let open: boolean;
  let percentValue: number;
  let percentAmount: number;

  const dispatch = createEventDispatcher();

  function computePercent(): void {
    if (percentValue > 100) percentValue = 100;
    else if (percentValue < 0) percentValue = 0;

    percentAmount = (amount / 100) * percentValue;
  }

  function applyPercent(): void {
    payment.amount = percentAmount;
    open = false;
    dispatch('paymentUpdated');
  }

  function handleKeydown(event: KeyboardEvent) {
    if( event.key === "Enter") {
        applyPercent();
    }
  }
</script>

<Dialog.Root bind:open={open}>
  <Dialog.Trigger asChild let:builder>
    <Button builders={[builder]} size="sm" class="w-24" variant="secondary" disabled={payment.paymentCompleted}>
      <CornerLeftUp class="mr-2 h-4 w-4" />
      {title}
    </Button>
  </Dialog.Trigger>
  <Dialog.Content class="sm:max-w-[425px]">
    <Dialog.Header>
      <Dialog.Title>
        {$t("page.projects.detail.schedule.percent-title")}
      </Dialog.Title>
    </Dialog.Header>
    <div class="grid gap-4 py-4">
      <div class="grid grid-cols-2 items-center gap-4">
        <Label for="name" class="text-right">
          {$t("page.projects.detail.schedule.percent")}
        </Label>
        <div class="flex flex-row items-center gap-2">
          <Input
            type="number"
            class="w-24 text-center"
            min={0}
            max={100}
            on:input={computePercent}
            bind:value={percentValue}
            on:keydown={handleKeydown}
          />
          <div>
            %
          </div>
        </div>
      </div>
      <div class="grid grid-cols-2 items-center gap-4">
        <div></div>
      <div>
        {percentAmount
          ? formatCurrency(percentAmount, $projectDraft.prices.currency)
          : ""}
      </div>
      </div>
    </div>
    <Dialog.Footer>
      <Button  on:click={() => applyPercent()}>
        {$t("global.messages.ok")}
      </Button>
    </Dialog.Footer>
  </Dialog.Content>
</Dialog.Root>
